export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-kr_kr.c6791968.png";